// 연령대 그룹을 가져오는 함수
export const getAgeGroups = (buyers) => {
    const ageGroups = {
        '20-24': 0,
        '25-29': 0,
        '30-34': 0,
        '35+': 0,
    };

    buyers.forEach(buyer => {
        const age = buyer.buyerAge; // 단순한 나이 정보
        if (age >= 20 && age <= 24) {
            ageGroups['20-24']++;
        } else if (age >= 25 && age <= 29) {
            ageGroups['25-29']++;
        } else if (age >= 30 && age <= 34) {
            ageGroups['30-34']++;
        } else {
            ageGroups['35+']++;
        }
    });

    return ageGroups;
};

// 전체 연령대 그룹을 가져오는 함수
export const getOverallAgeGroups = (data) => {
    const overallAgeGroups = {
        '20-24': 0,
        '25-29': 0,
        '30-34': 0,
        '35+': 0,
    };

    data.forEach(item => {
        Object.keys(item.ageGroups).forEach(group => {
            overallAgeGroups[group] += item.ageGroups[group];
        });
    });

    return overallAgeGroups;
};